module.exports = __webpack_public_path__ + "static/media/leo-logo.09db6efb.svg";